export const generateExpandCloseJS = (canvasDimension) => {
  const isNarrow = canvasDimension.width < 310;
  const { width, height } = canvasDimension;

  return `
      function expandBanner(id) {
        var foundEle = completeObj.find(function (element) {
          return element.id === id;
        });
  
        let expanHeight = document.getElementById("expand" + id).clientHeight || 0;
        let heightTracK = ${height} - expanHeight - foundEle.arrowHeight * 2 - 4;
  
        gsap.to("#expand" + id, 0, { display: "none" });
        gsap.to("#close" + id, 0, { display: "block" });
  
        gsap.to("#" + id, 0.5, {
          top: 0,
          ${isNarrow ? "" : "left: 0,"}
          height: ${height},
          ${isNarrow ? "" : `width: ${width},`}
        });
  
        gsap.to("#" + id + "ISIInfo", 0.5, {
          ${isNarrow ? "" : "left: 0,"}
          height: (${height} - expanHeight),
          ${isNarrow ? "" : `width: ${width},`}
        });
  
        gsap.to("#" + id + "viewport", 0.5, { top: 0, height: (${height} - expanHeight) });
  
        gsap.to("#scrollbar" + id, 0.5, { height: heightTracK });
  
        gsap.to("#" + id + "track", 0.5, {
          height: heightTracK,
          ${isNarrow ? "onUpdate" : "onComplete"}: function () {
            updateTiny(id, heightTracK);
          }
        });
      }
  
      function closeBanner(id) {
        var foundEle = completeObj.find(function (element) {
          return element.id === id;
        });
  
        let topLeft = {};
        if (animationObjecStringified !== "{}") {
          for (let x in animationObjecStringified) {
            if (x === id && animationObjecStringified[x].animation.length > 0) {
              topLeft = animationObjecStringified[x].animation[animationObjecStringified[x].animation.length - 1];
            }
          }
        }
  
        gsap.to("#expand" + id, 0, { display: "block" });
        gsap.to("#close" + id, 0, { display: "none" });
  
        gsap.to("#" + id, 0.5, {
          top: Object.keys(topLeft).length ? topLeft.y : foundEle.compTop,
          height: foundEle.compHeight,
          ${isNarrow ? "" : "left: foundEle.compLeft,"}
          ${isNarrow ? "" : "width: foundEle.compWidth,"}
        });
  
        gsap.to("#" + id + "ISIInfo", 0.5, {
          height: foundEle.compHeight + (foundEle.arrowHeight === 0 ? 0 : 2) - foundEle.expandHeight,
          ${isNarrow ? "" : "width: foundEle.compWidth,"}
        });
  
        gsap.to("#" + id + "viewport", 0.5, {
          top: 0,
          height: foundEle.compHeight
        });
  
        let heightTracK = foundEle.compHeight - foundEle.arrowHeight * 2 - (foundEle.arrowHeight === 0 ? 0 : 2) - foundEle.expandHeight;
  
        gsap.to("#scrollbar" + id, 0.5, { height: heightTracK });
  
        gsap.to("#" + id + "track", 0.5, {
          height: foundEle.trackHeight,
          onUpdate: function () {
            updateTiny(id, foundEle.trackHeight);
          }
        });
      }
  
      function updateTiny(id, heightTracK, heightThumb = null) {
        let tinyscrollbar = $("#" + id + "ISIInfo").data("plugin_tinyscrollbar");
        tinyscrollbar.options.trackSize = heightTracK;
        if(heightThumb){
          tinyscrollbar.options.thumbSize = heightThumb
        }
        tinyscrollbar.update(0);
      };
    `;
};

export const handleCompAspectRatio = (compSelected, name, newVal) => {
  let oldWidth = compSelected.componentStyles.width;
  let oldHeight = compSelected.componentStyles.height;
  if (oldHeight == 0) {
    oldHeight = 1;
  }
  if (oldWidth == 0) {
    oldWidth = 1;
  }
  const aspectRatio = oldWidth / oldHeight;
  let newHeight;
  let newWidth;
  if (name == "width") {
    newHeight = newVal / aspectRatio;
    newWidth = newVal;
    compSelected.componentStyles.height = newHeight;
  }
  if (name == "height") {
    newWidth = newVal * aspectRatio;
    newHeight = newVal;
    compSelected.componentStyles.width = newWidth;
  }
};

export function convertHex(hexCode, opacity = 1) {
  if (!hexCode) return;
  var hex = hexCode.replace("#", "");

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  var r = parseInt(hex.substring(0, 2), 16),
    g = parseInt(hex.substring(2, 4), 16),
    b = parseInt(hex.substring(4, 6), 16);
  if (opacity > 1 && opacity <= 100) {
    opacity = opacity / 100;
  }

  return "rgba(" + r + "," + g + "," + b + "," + opacity + ")";
}

export const convertRgbaStrToObj = (val) => {
  let obj = { r: "", g: "", b: "", a: "" };
  let newVal = !val.startsWith("rgb") ? val[2] : val;

  val = newVal
    .substr(
      newVal.indexOf("(") + 1,
      newVal.indexOf(")") - newVal.indexOf("(") - 1
    )
    .split(",");
  obj.r = val[0].replace(/\D/g, "");
  obj.g = val[1].replace(/\D/g, "");
  obj.b = val[2].replace(/\D/g, "");
  obj.a = val[3].replace(/\D/g, "");
  return obj;
};

export function rgb2hex(rgb) {
  rgb = rgb.match(
    /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
  );
  return rgb && rgb.length === 4
    ? "#" +
        ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2)
    : "";
}

export function createdDate(dateString) {
  const createdDate = new Date(dateString);
  const currentDate = new Date();

  // Step 1: Set the time portion of both dates to 00:00:00 to ignore time difference
  createdDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  // Step 2: Calculate the difference in days
  const timeDifference = currentDate - createdDate;
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  // Step 3: Determine the output
  if (daysDifference === 0) {
    return "Today"; // Same day
  } else if (daysDifference === 1) {
    return "Yesterday"; // One day ago
  } else {
    return `${daysDifference} days ago`; // More than one day ago
  }
}

export function dataURItoBlob(dataURI) {
  var binary = atob(dataURI.split(",")[1]);
  var array = [];
  for (var i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
}

export function getRandomString(length) {
  var randomChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var result = "";
  for (var i = 0; i < length; i++) {
    result += randomChars.charAt(
      Math.floor(Math.random() * randomChars.length)
    );
  }
  return result;
}

export const renderTheFontLink = (fontFamily) => {
  if (fontFamily.startsWith(" ")) fontFamily = fontFamily.substring(1);
  let tempFont = fontFamily?.split(" ").join("+");
  let url = `https://fonts.googleapis.com/css2?family=${tempFont}:wght@100;200;300;400;500;600;700;800;900&display=swap`;
  var link = document.createElement("link");
  link.href = url;
  link.rel = "stylesheet";
  link.type = "text/css";
  document.getElementsByTagName("head")[0].appendChild(link);
  return `<link rel=${"stylesheet"} href= "${url}">`;
};

export const amPmConverter = (timeString) => {
  const date = new Date();
  let day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getDay()];
  let month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ][date.getMonth()];
  let year = date.getFullYear();
  let time = timeString.split(" ")[1];
  let hour = time.split(":")[0];
  let min = time.split(":")[1];
  hour =
    hour > 12
      ? "0" + (hour - 12) + ":" + min + "pm"
      : hour + ":" + min + `${hour === "12" ? "pm" : "am"}`;
  return hour + "," + " " + day + "." + " " + month + " " + year;
};

export const convertTextToBullets = (text, trackChangesObj = null) => {
  if (trackChangesObj && typeof trackChangesObj === "object") {
    const categories = [];
    Object.entries(trackChangesObj).forEach(([key, value]) => {
      const formattedKey = key
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase());

      categories.push(`<li>${formattedKey}: ${value || ""}</li>`);
    });

    if (categories.length === 0) {
      categories.push("<li></li>");
    }
    return `<ul style="padding-left:16px">${categories.join("")}</ul>`;
  }

  if (text) {
    if (typeof text === "object") {
      const categories = [];

      Object.entries(text).forEach(([key, value]) => {
        const formattedKey = key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase());

        categories.push(`<li>${formattedKey}: ${value || ""}</li>`);
      });

      if (categories.length === 0) {
        categories.push("<li></li>");
      }

      return `<ul style="padding-left:16px">${categories.join("")}</ul>`;
    }

    if (
      typeof text === "string" &&
      (text.includes("<ul>") || text.includes("<li>"))
    ) {
      return text;
    }
    if (typeof text === "string") {
      const lines = text
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter((line) => line !== "");

      if (lines.length === 0) {
        return "<ul><li></li></ul>";
      }

      return `<ul style="padding-left:16px">${lines
        .map((line) => `<li>${line}</li>`)
        .join("")}</ul>`;
    }
  }
  return "<ul><li></li></ul>";
};
export const convertBulletsToTrackChanges = (html) => {
  if (!html) return {};

  const trackChanges = {};
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const listItems = tempDiv.querySelectorAll("li");

  listItems.forEach((item) => {
    const text = item.textContent || "";
    const colonIndex = text.indexOf(":");

    if (colonIndex > 0) {
      const key = text.substring(0, colonIndex).trim();
      const value = text.substring(colonIndex + 1).trim();
      if (value.trim()) {
        const camelCaseKey = key
          .toLowerCase()
          .replace(/\s(.)/g, (_, char) => char.toUpperCase())
          .replace(/\s/g, "");

        trackChanges[camelCaseKey] = value;
      }
    }
  });

  return trackChanges;
};

export const extractListItemsAsText = (htmlText) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlText;

  const lis = tempDiv.querySelectorAll("li");
  const lines = Array.from(lis).map((li) => li.textContent.trim());

  return lines.join("\n");
};

export function rgbaStringToObject(rgbaString) {
  if (!rgbaString) {
    return;
  }
  let match = rgbaString.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);

  if (!match) return null;

  return {
    r: parseInt(match[1]),
    g: parseInt(match[2]),
    b: parseInt(match[3]),
    a: parseFloat(match[4]),
  };
}

export function createComponentStyleUpdater(component, propertyName) {
  return (value) => {
    const updatedComponent = { ...component };
    if (!updatedComponent.componentStyles) {
      updatedComponent.componentStyles = {};
    }
    updatedComponent.componentStyles[propertyName] = value;
    return updatedComponent;
  };
}

export function fontStyleToggle(component, styleType) {
  if (!component || !component.componentStyles) return component;
  const updatedComponent = JSON.parse(JSON.stringify(component));
  const styles = {
    bold: {
      toggleProp: "boldClick",
      props: {
        fontWeightBold: { onValue: "bold", offValue: "normal" },
        fontWeight: { onValue: "bold", offValue: "normal" },
      },
      resetToggleProp: true,
    },
    italic: {
      toggleProp: "italicClick",
      props: {
        fontStyle: { onValue: "italic", offValue: "unset" },
      },
    },
    underline: {
      toggleProp: "underlineClick",
      props: {
        textDecUnderline: { onValue: "underline", offValue: "unset" },
      },
    },
    uppercase: {
      toggleProp: "uppercaseClicked",
      props: {
        textTransform: { onValue: "uppercase", offValue: "unset" },
      },
    },
    strikeout: {
      toggleProp: "strikeThroughClicked",
      props: {
        textDecoration: { onValue: "line-through", offValue: "unset" },
      },
    },
  };
  const style = styles[styleType];
  if (!style) return component;
  const newToggleValue = !updatedComponent.componentStyles[style.toggleProp];
  updatedComponent.componentStyles[style.toggleProp] = newToggleValue;
  Object.entries(style.props).forEach(([propName, values]) => {
    updatedComponent.componentStyles[propName] = newToggleValue
      ? values.onValue
      : values.offValue;
  });
  if (!newToggleValue && style.resetToggleProp) {
    updatedComponent.componentStyles[style.toggleProp] = false;
  }
  if (
    newToggleValue &&
    (styleType === "underline" ||
      styleType === "uppercase" ||
      styleType === "strikeout")
  ) {
    updatedComponent._skipLayerUpdate = true;
  }

  return updatedComponent;
}

export function updateComponentInArray(components, updatedComponent) {
  if (!updatedComponent || !updatedComponent.id) return components;

  return components.map((comp) => {
    if (comp.id === updatedComponent.id) {
      const newComp = { ...comp };
      Object.entries(updatedComponent.componentStyles).forEach(
        ([key, value]) => {
          if (!newComp.componentStyles) {
            newComp.componentStyles = {};
          }
          newComp.componentStyles[key] = value;
        }
      );

      return newComp;
    }
    return comp;
  });
}

// utility.js - Alignment utility functions

export const updateAlignment = (alignType, selectedComp, layerData) => {
  const tempSelected = { ...selectedComp };
  const tempLayerData = [...layerData];

  // Set alignment on selected component
  tempSelected.componentStyles.textAlign = alignType;

  // Update alignment in layer data
  tempLayerData.forEach((entry, index) => {
    if (entry.id === tempSelected.id) {
      tempLayerData[index].componentStyles.textAlign = alignType;
    }
  });

  return { selectedComponent: tempSelected, layerCompData: tempLayerData };
};

export const applyListFormat = (listType, index, froalaRef, layerData) => {
  const tempLayerData = [...layerData];

  const editor = getFroalaEditorInstance(index, froalaRef);
  if (!editor) return tempLayerData;

  // Apply formatting
  editor.editor.edit.on();
  editor.editor.events.focus();
  editor.getEditor().commands.selectAll();
  editor.getEditor().lists.format(listType);

  // Update content
  const newHtml = editor?.editor?.html.get();
  if (tempLayerData[index]?.froalaText) {
    tempLayerData[index].froalaText = newHtml;
  }

  // Clear selection
  editor.getEditor().selection.clear();

  return tempLayerData;
};

export const getFroalaEditorInstance = (index, froalaRef) => {
  if (
    froalaRef &&
    froalaRef.current &&
    froalaRef.current[index] &&
    froalaRef.current[index].getEditor() &&
    index !== undefined
  ) {
    return froalaRef.current[index];
  }
  return null;
};
